module.exports = __webpack_public_path__ + "img/calendar-banner-des.6f5b3210.gif";